export default __webpack_public_path__ + "static/Hazard_Suit_Shirt-68045bb41b094a99eb46e4ed5f93900f.png";